<div class="container space-top layout-row-wrap gap-2percent layout-lt-md-column">
  <mat-form-field class="flex-31">
    <mat-label>{{ 'labels.inputs.Job Name' | translate }}</mat-label>
    <mat-select [formControl]="jobName" (selectionChange)="getWorkflowJobSteps($event.value)">
      @for (job of jobNameOptions; track job) {
        <mat-option [value]="job">
          {{ job | translateKey: 'catalogs' }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (jobStepName) {
    <div class="action-button gap-25percent">
      <button mat-raised-button color="primary" (click)="addJobStep()">
        <fa-icon icon="plus" class="m-r-10"></fa-icon>{{ 'labels.buttons.Link Job Step' | translate }}
      </button>
    </div>
  }

  @if (jobStepsData.length > 0) {
    <div class="mat-elevation-z8 container">
      <table
        mat-table
        [dataSource]="jobStepsData"
        #table
        cdkDropList
        [cdkDropListData]="jobStepsData"
        (cdkDropListDropped)="dropTable($event)"
      >
        <ng-container matColumnDef="stepName">
          <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Step Name' | translate }}</th>
          <td mat-cell *matCellDef="let jobStep">{{ jobStep.stepName }}</td>
        </ng-container>
        <ng-container matColumnDef="stepOrder">
          <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Order' | translate }}</th>
          <td mat-cell *matCellDef="let jobStep">{{ jobStep.order }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Actions' | translate }}</th>
          <td mat-cell *matCellDef="let row; let rowIndex = index">
            <button
              type="button"
              mat-icon-button
              color="warn"
              (click)="removeJobStep(rowIndex)"
              matTooltip="{{ 'tooltips.Delete' | translate }}"
              matTooltipPosition="left"
            >
              <fa-icon icon="trash"></fa-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row cdkDrag [cdkDragData]="row" *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  }

  @if (stepOrderHasChanged) {
    <div class="container margin-t space-top layout-row gap-2percent layout-align-center layout-column-xs">
      <button mat-raised-button [routerLink]="['../']">
        {{ 'labels.buttons.Cancel' | translate }}
      </button>
      <button mat-raised-button color="primary" (click)="saveChanges()">
        {{ 'labels.buttons.Apply Changes' | translate }}
      </button>
    </div>
  }

  @if (jobStepsData.length > 0 && !stepOrderHasChanged) {
    <div class="container space-top">
      <LOSx-workflow-diagram [jobStepsData]="jobStepsData"></LOSx-workflow-diagram>
    </div>
  }
</div>
